/**
 * @todo Move to the retrieval widget
 */

import React from 'react';

import { useUserRetrievalTranslation } from '@app/widgets/user-retrieval/hooks/useUserRetrievalTranslation';
import { RetrievalWizardButtons } from '@app/widgets/user-retrieval/RetrievalWizardButtons';

import { FieldLocator, WizardStep, WizardStepProps } from '.';
import { ContactUsAlert } from '../components/configurable-wizards/ContactUsAlert';

import { useWizardStepStateContext } from './WizardStateStateContext';

export interface RetrievalWizardStepProps {
  readonly continueButtonTitle?: string;
  readonly stepLocators: readonly FieldLocator[];
  readonly wizardStepProps: WizardStepProps;
}
export const RetrievalWizardStep: React.FC<RetrievalWizardStepProps> = ({
  continueButtonTitle,
  stepLocators,
  wizardStepProps,
}) => {
  const { allowBackRedirect } = useWizardStepStateContext();
  const { t } = useUserRetrievalTranslation();

  const continueTitle: string = continueButtonTitle
    || t('user-retrieval.wizard.buttons.continue.title|Wizard\'s continue button text', 'Continue');

  return (
    <WizardStep
      afterFieldsContent={() => (
        <ContactUsAlert />
      )}
      buttons={({ back, cancel }) => (
        <RetrievalWizardButtons
          showBackButton={allowBackRedirect}
          back={back}
          cancel={cancel}
          continueTitle={continueTitle}
        />
      )}
      locators={stepLocators}
      {...wizardStepProps}
    />
  );
};
